import {
  DebtsAlertBanner,
  DebtsAlertModal,
  DeviceProfileModal,
  DevicesAnalysisViewModal,
  UserPreferencesModal,
  UserProfileModal,
  UserProfileUpdateModal,
} from '@/features/';
import useAuth from '@/hooks/useAuth';
import { useI18n } from '@/hooks/useI18n';
import { DeviceUserAccessGlobalModals } from '@features/access';
import AnnouncementsViewModal from '@features/announcements/components/AnnouncementsViewModal';
import { useAuthorizationRefetch } from '@features/authorization';
import UpdateDeviceAlertsModal from '@features/createDeviceAlerts/components/CreateDeviceAlerts';
import SaveHardwareConfigurationModal from '@features/createDeviceConfiguration/components/SaveHardwareConfiguration';
import { DeviceConfigurationGlobalModals } from '@features/deviceConfigurationModal';
import DeviceDataConfigurationModal from '@features/deviceDataConfigurationModal';
import { DeviceObservationsModals } from '@features/deviceObservations';
import DGAModals from '@features/dga/components/modals/DGAModals';
import { useGatesMovementGlobalActions } from '@features/gateAdministration/hooks/useGatesMovementGlobalActions';
import { GroupedIssuesModal } from '@features/integrations';
import { SmaSuccessTableModal, SmaUpsertModal } from '@features/sma';
import SMAReportsTableModal from '@features/sma/components/TableModal';
import { SaveUserModalGlobal } from '@features/userSaveModal';
import DeleteUserModal from '@features/users/components/modals/DeleteUserModal';
import ExtendTemporaryUserModal from '@features/users/components/modals/ExtendTemporaryUserModal';
import ExtendTemporaryUserTokenModal from '@features/users/components/modals/ExtendTemporaryUserTokenModal';
import SimulateUserModal from '@features/users/components/modals/SimulateUserModal';
import PicturePreview from './PicturePreview';
import GlobalSnackbar from './Snackbar';
import CreateMeasurementAdapterModal from './optionsMenu/dialogs/CreateMeasurementAdapterModal';
import ManualDataDetailsAdapterModal from './optionsMenu/dialogs/ManualDataDetailsAdapterModal';
import { DeviceAlertsModal } from '@features/deviceAlertsModal';
import { DevicesGraveyard } from '@features/devicesGraveyard';
import { UsersGraveyard } from '@features/usersGraveyard';
import { DisableAlertsModal } from '@features/deviceAlertsModal/components/disableAlertsModal';
import { Confetti } from './Confetti';
import { RawDataModal } from '@features/deviceAlertsModal/components/rawDataModal';
import { UserConfigurationModal } from '@features/userConfigurationModal';
import { CreateDeviceModal } from '@features/createDevice';
import { DownloadDataModal } from '@features/downloadData/components/DownloadDataModal';
import { ReportProblemModal } from '@features/reportProblem';
import { OrganizationPreferencesModal } from '@features/organizationPreferences';
import { DgaTicketModal } from '@features/dgaTicket';
import { CreateReportModal } from '@features/reports2/components/createModal/CreateReportModal';
import { AlertsConfigurationModal } from '@features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal';
import { UserActivityLogsModal } from '@features/userActivityLogs';
import { MoveGateModal } from '@features/moveGateModal';
import { GateOperationModal } from '@features/gateOperationModal';
import { GateMessagesSubscription } from '@features/gateCommon/components/GateMessagesSubscription';
import { AfterUpdateTasksModal } from '@features/changeOperationalState/components/AfterUpdateTasksModal';
import { UpdateMultipleDevicesTagsModal } from '@features/updateMultipleDevicesTags';
import { ResendCredentialsModal } from '@features/resendCredentialsModal';
import { TriggerConfigUpdateModal } from '@features/deviceConfiguration/components';

const LoggedInGlobalComponents = () => {
  useGatesMovementGlobalActions();
  useI18n();
  useAuthorizationRefetch();

  return (
    <>
      {/* Place for global components that needs auth */}
      <UserPreferencesModal />
      <UserProfileModal />
      <UserProfileUpdateModal />
      <SimulateUserModal />
      <DeleteUserModal />
      <SaveUserModalGlobal />
      <PicturePreview />
      <DebtsAlertModal />
      <DebtsAlertBanner />
      <AnnouncementsViewModal />
      <DevicesAnalysisViewModal />
      <DeviceProfileModal />
      <DeviceConfigurationGlobalModals />
      <DeviceDataConfigurationModal />
      <DGAModals />
      <UpdateDeviceAlertsModal />
      <AlertsConfigurationModal />
      <DeviceObservationsModals />
      <CreateMeasurementAdapterModal />
      <ManualDataDetailsAdapterModal />
      <SmaUpsertModal />
      <SmaSuccessTableModal />
      <SMAReportsTableModal />
      <ExtendTemporaryUserModal />
      <ExtendTemporaryUserTokenModal />
      <SaveHardwareConfigurationModal />
      <DeviceUserAccessGlobalModals />
      <DevicesGraveyard />
      <UsersGraveyard />
      <GroupedIssuesModal />
      <DeviceAlertsModal />
      <DisableAlertsModal />
      <RawDataModal />
      <UserConfigurationModal />
      <CreateDeviceModal />
      <DownloadDataModal />
      <ReportProblemModal />
      <OrganizationPreferencesModal />
      <DgaTicketModal />
      <CreateReportModal />
      <UserActivityLogsModal />
      <MoveGateModal />
      <GateOperationModal />
      <GateMessagesSubscription />
      <AfterUpdateTasksModal />
      <UpdateMultipleDevicesTagsModal />
      <ResendCredentialsModal />
      <TriggerConfigUpdateModal />
    </>
  );
};

const GlobalComponents = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {/* No auth needed global components */}
      <GlobalSnackbar />
      <Confetti />
      {isAuthenticated && <LoggedInGlobalComponents />}
    </>
  );
};

export default GlobalComponents;
